import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Palette({ idVariant = '', className }: Props) {
  return (
    <IconBase name="palette" w={26} h={25} className={className}>
      <path d="M4.59923 6.19183C4.59923 5.23595 5.40514 4.46105 6.39928 4.46105C7.39343 4.46105 8.19934 5.23595 8.19934 6.19183C8.19934 7.14771 7.39343 7.92261 6.39928 7.92261C5.40514 7.92261 4.59923 7.14771 4.59923 6.19183Z" stroke="currentColor" strokeWidth="1.38462" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15.3998 18.3078L18.9999 14.8462M11.9725 23.184C13.3166 24.3413 15.3446 24.3655 16.7727 23.304C19.5565 21.242 22.0516 18.8429 24.1961 16.1662C25.3001 14.7931 25.2749 12.8431 24.0713 11.5508C20.8214 8.05743 17.3345 4.77484 13.6334 1.72459C13.2653 1.41664 12.8063 1.22703 12.3205 1.18228C10.1653 0.993053 3.95628 0.601895 2.27143 2.22306C0.586576 3.84422 0.992189 9.81311 1.19019 11.8854C1.23673 12.3524 1.43393 12.7938 1.75421 13.1477C4.92617 16.7064 8.33974 20.0591 11.9725 23.184Z" stroke="currentColor" strokeWidth="1.38462" strokeLinecap="round" strokeLinejoin="round"/>
    </IconBase>
  )
}

export default Palette
